import { useTranslation } from 'react-i18next'

import { DeliveryMethodInfo } from '@reveni-io/reveni-ui'

import WhiteLabelThemeProvider from '@/configuration/components/WhiteLabelThemeProvider/WhiteLabelThemeProvider'

import { getReturnMethodMessage, getReturnMethodTitle, getReturnMethodType } from './helpers'
import * as Styles from './styles'

const ReturnMethodsPreview = ({ activeReturnMethod, customCopies, lang, isActive, merchantInfo, address }) => {
  const { t } = useTranslation()
  const copies = isActive ? customCopies : {}
  const type = getReturnMethodType(activeReturnMethod)
  const title = getReturnMethodTitle(activeReturnMethod)
  const message = getReturnMethodMessage(activeReturnMethod, copies, lang)

  return (
    <Styles.Container>
      <WhiteLabelThemeProvider>
        <Styles.PreviewContent>
          <DeliveryMethodInfo
            deliveryMethod={{
              type,
              name: t(title),
              requires_address: true,
              delivery_address: address,
            }}
            shippingAddress={address}
            message={message}
            merchantInfo={merchantInfo}
          />
        </Styles.PreviewContent>
      </WhiteLabelThemeProvider>
    </Styles.Container>
  )
}

export default ReturnMethodsPreview
